import Salesreport from "../components/salesreport/salesreport";
import ContactLEad from "../components/contactlead/conlead";
function Salesreportt(){
    return(
        <>
      <Salesreport/>
      <ContactLEad/>
        </>
    )
}
export default Salesreportt